import { marqueeItems, en } from "@/content";
import { useLang } from "@/lang";

export default function Marquee() {
    const { lang } = useLang();
    const items = lang === "en" ? en.marqueeItems : marqueeItems;
    const row = [...items, ...items];
    return (
        <div
            data-testid="skills-marquee"
            className="overflow-hidden border-2 border-ink bg-ink py-4"
            aria-hidden="true"
        >
            <div className="marquee-track flex w-max items-center gap-8 whitespace-nowrap pr-8">
                {row.map((item, i) => (
                    <span key={i} className="flex items-center gap-8">
                        <span className="font-accent-serif text-2xl text-paper md:text-3xl">
                            {item}
                        </span>
                        <span className="block h-2 w-2 bg-paper" />
                    </span>
                ))}
            </div>
        </div>
    );
}
